
export default {
  props:{
    openDialog:{
      type: Boolean,
      default:  function () {
        return false;
      }},

    message: {type: String, default: ""},
    onClick: {
      type: Function,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  methods:{
    handleClose(){
      this.onClose()
    }
  }
}
